module.exports = __webpack_public_path__ + "static/media/gold-tokens.20ec1f7b.png";